var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgArrowLine = function SvgArrowLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 12,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.136 5.503 5.818.834a.764.764 0 0 1 1.078 0 .759.759 0 0 1 0 1.076L2.753 6.04l4.143 4.131a.759.759 0 0 1 0 1.075.764.764 0 0 1-1.079 0L1.136 6.578a.757.757 0 0 1 0-1.075Z",
    fill: "#fff"
  })));
};
export default SvgArrowLine;